import { render, staticRenderFns } from "./PulsatingDot.vue?vue&type=template&id=8c71e4d4&scoped=true&"
import script from "./PulsatingDot.vue?vue&type=script&lang=js&"
export * from "./PulsatingDot.vue?vue&type=script&lang=js&"
import style0 from "./PulsatingDot.vue?vue&type=style&index=0&id=8c71e4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71e4d4",
  null
  
)

export default component.exports